<div class="ng-scope">
    <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#">Transactional Grid</a>
    </nav>

    <div class="container-fluid" style="margin-bottom: 1em; padding-left: 0; padding-right: 0;">
        <form class="example-form">
            <div class="card">
                <div class="card-header">
                    <button class="btn ng-binding" style="float: right;" (click)="toggle()">
                        {{buttonName}}
                    </button>
                </div>

                <div class="card-body animate-show-hide" id="filterGroup" *ngIf="ShowFilters">
                    <div class="row">
                        <div class="col-sm-2">
                            <b>
                                Client
                            </b>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let cust of custs" [value]="cust.value">
                                        {{cust.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-2">
                            <b>
                                Vendor Name
                            </b>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <input matInput type="text" name="vendor" id="vendor">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 0.5em;">
                        <div class="col-sm-2">
                            <b>
                                Client Transaction ID
                            </b>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <input matInput type="text" name="vendor" id="vendor">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-2">
                            <b>
                                AFS Internal Tracking#
                            </b>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <input matInput type="text" name="vendor" id="vendor">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 0.5em;">
                            <div class="col-sm-2">
                                <b>
                                    Event Type
                                </b>
                            </div>
                            <div class="col-sm-4">
                                <mat-form-field>
                                    <mat-select placeholder="select" [formControl]="eveType" 
                                    [(value)]="selectedTypes" multiple>
                                      <mat-option *ngFor="let  typ of eveTypesList" [value]="typ">{{typ}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-2">
                                <b>
                                   But Not
                                </b>
                            </div>
                            <div class="col-sm-4">
                                <mat-form-field>
                                    <mat-select placeholder="select" [formControl]="butNot" 
                                    [(value)]="selectedList" multiple>
                                      <mat-option *ngFor="let  butNt of butNotList" [value]="butNt">{{butNt}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
        

                    <div class="row" style="margin-top: 0.5em;">
                        <div class="col-sm-2">
                            <b>
                                From
                            </b>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="picker" name="from" id="from">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-2">
                            <b>
                                To
                            </b>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="pickers" name="to" id="to">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="pickers"></mat-datepicker-toggle>
                                <mat-datepicker #pickers></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="row" style="margin-top: 1em;">
                            <div class="col-sm-2">
                                <button ng-click="$ctrl.searchClicked()" type="button" class="btn btn-primary">
                                    SEARCH
                                </button>
                            </div>

                            <div class="col-sm-8">
                                &nbsp;
                            </div>
                            <div class="col-sm-2">
                                <button ng-click="$ctrl.clearFilters()" type="button" class="btn" style="float: right;">
                                    CLEAR FILTERS
                                </button>
                            </div>
                        </div>
                    </div>